<template>
  <div class="check-in-report">
    <!-- <div style="margin-bottom: 10px">
      <el-input
        v-model="search.id"
        placeholder="學生編號"
        style="width: 200px"
        size="small"
      />
      <el-date-picker
        v-model="search.date"
        type="daterange"
        :clearable="false"
        range-separator="-"
        :start-placeholder="$t('app.paymentDateStart')"
        :end-placeholder="$t('app.paymentDateEnd')"
        size="small"
        style="margin-left: 1rem"
      >
      </el-date-picker>
      <el-button
        type="primary"
        @click="reset"
        size="small"
        style="margin-left: 1rem"
        >{{ $t("app.reset") }}</el-button
      >
      <el-button
        type="success"
        icon="el-icon-search"
        @click="getList"
        size="small"
        >查詢報表</el-button
      >
    </div> -->

    <!-- <el-select
      v-model="columnKey"
      style="width: 200px"
      multiple
      collapse-tags
      placeholder="自定義列"
      clearable
      size="small"
    >
      <el-option
        v-for="item in initColumn"
        :key="item.Code"
        :label="item.Display"
        :value="JSON.stringify(item)"
        size="small"
      >
      </el-option>
    </el-select>
    <BookTypeOption v-model="bookType" style="margin-left: 20px" /> -->
    <el-button
      style="margin-bottom: 20px; margin-left: 1rem"
      type="primary"
      icon="el-icon-document"
      @click="handleDownload"
      size="small"
    >
      Export
    </el-button>
    <div class="table-container">
      <el-table
        :key="tableKey"
        stripe
        :data="tableData"
        style="width: 100%; color: black"
        ref="multipleTable"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <template v-for="col in column">
          <el-table-column
            :key="col.Code"
            align="center"
            :label="col.Display"
            :prop="col.Code"
          >
            <template slot-scope="scope">
              <div
                :class="{
                  'word-break': ['Name'].includes(col.Code)
                }"
              >
                {{ scope.row[col.Code] }}
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>

<script>
import BookTypeOption from "./components/BookTypeOption";
import { getList } from "@/api/report/bedtagsBalanceReport";
import { delEmpty, downloadFileByBlob, formatDate } from "@/utils/utils";
import { download } from "@/api/download";
export default {
  components: { BookTypeOption },
  data() {
    return {
      tableKey: true,
      filename: "",
      autoWidth: true,
      bookType: "",
      typeList: [],
      columnKey: [],
      initColumn: [],
      search: {
        id: "",
        date: []
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
      floorList: [],
      title: "",
      exportUrl: "/BedTagsBalanceReport/Export"
    };
  },
  created() {
    this.init();
  },
  computed: {
    column() {
      if (this.columnKey.length < 1) {
        return this.initColumn;
      }
      return this.columnKey.map(i => JSON.parse(i));
    }
  },
  watch: {
    columnKey: {
      handler() {
        this.tableKey = !this.tableKey;
      },
      deep: true
    }
  },
  methods: {
    init() {
      this.initColumn = [
        // {
        //   Display: "School Year",
        //   Code: "SchoolYear",
        //   BindDataColumn: null,
        //   Width: "100px"
        // },
        {
          Display: "BedTags Code",
          Code: "BedTagsCode",
          BindDataColumn: null,
          Width: "100px"
        },
        {
          Display: "Total Number",
          Code: "TotalNumbers",
          BindDataColumn: null,
          Width: "100px"
        },
        {
          Display: "Balance Number",
          Code: "BalanceNumbers",
          BindDataColumn: null,
          Width: "100px"
        }
      ];
      this.getList();
    },
    getList() {
      getList(
        delEmpty({
          SchoolYear: this.search.SchoolYear || "",
          BedTagCode: this.search.BedTagsCode,
          PageIndex: this.currentPage,
          PageSize: this.size
        })
      ).then(res => {
        this.total = res.data.Total;
        this.tableData = res.data;
      });
    },
    reset() {
      this.search.id = "";
      this.search.date = [];
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleDownload() {
      download(this.exportUrl, {
        ExportMethod: this.bookType,
        HeaderValue: this.columnKey.map((_) => JSON.parse(_).Code).join(","),
        StudentID: this.search.id,
        BeginFilterDateTime: this.search.date[0] || "",
        EndFilterDateTime: this.search.date[1] || ""
      }).then(content => {
        let downloadFileExtension = this.selectExtension(this.bookType);
        var blobContent = new Blob([content]);
        downloadFileByBlob(
          blobContent,
          "BedTagsBalance Report-" +
            formatDate(new Date(), "yyyy-MM-dd") +
            downloadFileExtension
        );
      });
    },
    selectExtension(bookType) {
      if (bookType === "xlsx") {
        return ".xls";
      } else if (bookType === "word") {
        return ".doc";
      } else if (bookType === "pdf") {
        return ".pdf";
      } else {
        return ".xls";
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    createCellPos(n) {
      var ordA = "A".charCodeAt(0);
      var ordZ = "Z".charCodeAt(0);
      var len = ordZ - ordA + 1;
      var s = "";
      while (n >= 0) {
        s = String.fromCharCode((n % len) + ordA) + s;
        n = Math.floor(n / len) - 1;
      }
      return s;
    }
  }
};
</script>
<style lang="scss" scoped>
.check-in-report {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 80px);
  .table-container {
    height: calc(100% - 170px);
    overflow: auto;
  }
}
</style>
